import { PropsWithChildren } from 'react';
import { useGetPortalSettingsQuery } from 'slices';

const CustomCssConfigProvider = ({ children }: PropsWithChildren<{}>) => {
  const { currentData: settings } = useGetPortalSettingsQuery();

  return (
    <>
      <style
        id="custom-css"
        dangerouslySetInnerHTML={{
          __html: settings?.customCssConfig.stylesheet || '',
        }}
      />
      {children}
    </>
  );
};

export default CustomCssConfigProvider;
